(function ($) {
  Drupal.behaviors.shadeNamesV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.shade-names-v1', context);
      var $list = $('.shade-names__grid', $template);
      var $name = $('.shade-names__grid--item', $list);

      $name.sort(function (a, b) {
        var aShade = $(a).data('shade-name');
        var bShade = $(b).data('shade-name');

        return aShade < bShade ? -1 : aShade > bShade ? 1 : 0;
      }).appendTo($list);
    },
    attached: false
  };
})(jQuery);
